import { useState } from "react";
import { visionURL } from "../../config/environment";

export const useGoogleMapsApiKey = () => {
  const [isLoading, setIsLoading] = useState(false);
  return {
    getGoogleMapsApiKey: async () => {
      setIsLoading(true);
      const response = await fetch(`${visionURL}/api/google_maps`, {
        credentials: "include"
      })
        .then(res => res.json())
        .then(res => res);
      setIsLoading(false);
      return response;
    },
    isLoading
  };
};
